// Texter vun der Startsäit (Home.jsx) — lëtzebuergesch Iwwersetzung vu fr/home.js.
// Déiselwecht Schlësselen, déiselwecht Reiefolleg. Markennimm (Joyful Reveal,
// Mirum Games, Pack Essentiel, Pack Premium) bleiwen oniwwersat.
export default {
  'home.seo.titre': 'Joyful Reveal - Gender-Reveal-Spill: spillt, fir d’Geschlecht vum Bëbee ze verroden | Mirum Games',
  'home.seo.description': 'Maacht aus Ärer Gender Reveal Party e Spill: 2 Equipen, lëschteg Froen, 11 Puzzlestécker ze gewannen an e lescht Stéck, dat d’Geschlecht vum Bëbee verréit. Séier Liwwerung a Lëtzebuerg, an der Belsch a Frankräich.',

  'home.etat.chargement': 'Gëtt gelueden...',

  'home.vitrine.badge': '🧩 Eis Kollektioun',
  'home.vitrine.description': 'En eenzegaartegt Konzept, dat aus der Uskënnegung vum Geschlecht vum Bëbee e lëschtegt Froen-an-Äntwerte-Spill mécht! Sammelt Är Famill a Frënn, bilt Equipen an erlieft zesummen dëse magesche Moment, deen Iech éiweg an Erënnerung bleift.',
  'home.vitrine.altProduit': 'Joyful Reveal Bieren - Ekologesche Puzzle, deen d’Geschlecht vum Bëbee verréit - Mirum Games',

  'home.packs.titre': 'Wielt Äre Pack',
  'home.packs.economisez': 'Spuert {pct}%',
  'home.packs.selectionne': '✓ Ausgewielt',
  'home.packs.selectionner': 'Auswielen',
  'home.packs.voirFiche': '📋 Déi komplett Produktsäit kucken',

  'home.recap.packChoisi': 'Gewielte Pack:',
  'home.recap.prixTotal': 'Gesamtpräis:',

  'home.genre.cestPour': 'Dat ass fir...',
  'home.genre.contenuPack': 'Inhalt vum Pack',
  'home.genre.packMixte': 'Gemëschte Pack: Meedchen + Jong dobäi!',
  'home.genre.versionGarcon': 'Versioun Jong virausgewielt',
  'home.genre.versionFille': 'Versioun Meedchen virausgewielt',

  // Variantebezeechnungen: fir d’Knäppercher Jong/Meedchen AN fir den
  // zesummegesate Produktnumm am Wuerekuerf (ee Schlëssel pro Variant).
  'home.variante.garcon': 'Jong',
  'home.variante.fille': 'Meedchen',
  'home.variante.mixte': 'Meedchen + Jong',

  'home.cta.ajouterPanier': '🛒 An de Wuerekuerf leeën',
  'home.cta.voirFichePack': '📋 Déi komplett Produktsäit vum {pack} kucken',
  'home.cta.magique': '✨ Kreéiert e magesche Moment mat Ärer Famill',

  'home.badges.cleEnMain': 'Direkt spillbereet',
  'home.badges.pretAOffrir': 'Prett fir ze verschenken',
  'home.badges.livraisonRapide': 'Séier Liwwerung',

  'home.concept.badge': '✨ Eist eenzegaartegt Konzept',
  // Sätz, déi ronderëm d’<strong> geschnidde sinn: virdrun / staarkt Wuert / duerno.
  'home.concept.question': 'E klengt Meedchen? E klenge Jong?',
  'home.concept.questionSuite': 'Kann jiddereen ronderëm Iech et kaum erwaarden ze wëssen, zu wéi enger Equipe Äre klenge Bëbee gehéiert?',
  'home.concept.annonce': 'Verkënnegt dës Neiegkeet op eng spilleresch an originell Manéier — mat eisem Spill!',
  'home.concept.puzzleAvant': 'Dëse Puzzle ass',
  'home.concept.puzzleMot': 'eenzegaarteg',
  'home.concept.puzzleApres': '— en entsteet Stéck fir Stéck an engem lëschtege Froen-an-Äntwerte-Spill, fir um Enn dat klengt Geheimnis vum Bëbee ze verroden.',
  'home.concept.experienceAvant': 'Vill méi wéi e Puzzle — dat hei ass en',
  'home.concept.experienceMot': 'Erliefnes vu Bäisammesinn a Freed',
  'home.concept.experienceApres': 'mat Frënn a Famill. Sammelt Är Léifsten, bilt Equipen a genéisst dësen eenzegaartege Moment an Ärem Liewen!',
  'home.concept.cadeauAvant': 'Egal ob Dir selwer zukünfteg Elteren sidd oder eng',
  'home.concept.cadeauMot': 'Gender Reveal Party',
  'home.concept.cadeauApres': 'fir e léiwe Mënsch organiséiert: eist Spill mécht aus dësem Dag garantéiert en nach onvergiesslechere Moment.',

  'home.instagram.badge': '📸 Magesch Momenter',
  'home.instagram.titre': 'Entdeckt eise Puzzle an Aktioun! 🎉',
  'home.instagram.sousTitre': 'Kuckt, wéi eis Clienten hir magesch Uskënnegung mat Joyful Reveal erliewen',
  'home.instagram.altReel': 'Zwee zukünfteg Elteren, ëmginn vu Puzzlestécker, Illustratioun Joyful Reveal',
  'home.instagram.voirSur': 'Op Instagram kucken',
  'home.instagram.momentTitre': 'En onvergiesslechte Moment',
  'home.instagram.momentTexte': 'Eis Puzzlen maachen aus der Uskënnegung en interaktivt a festlecht Erliefnes. Setzt d’Stécker a Famill zesummen an entdeckt zesummen dat grousst Geheimnis!',
  'home.instagram.jeuInteractif': 'Interaktivt Spill',
  'home.instagram.enFamille': 'A Famill',
  'home.instagram.suivezNous': 'Follegt eis op Instagram',
};
